import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import RegisterForm, { RegisterFormProps } from '../../components/forms/RegisterForm'
import ContentBox from '../../components/ContentBox'
import { TitleDescriptionProps } from '../../components/TitleDescription'
import { CalendarProps } from '../../components/Calendar'
import { SlotsProps } from '../../components/Slots'
import { ActionButtonProps } from '../../components/ActionButton'
import { FormErrorsProps } from '../../components/form/FormErrors'

import * as SC from './styled'

export type RegisterTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  registerForm: RegisterFormProps
  titleDescription: TitleDescriptionProps
  calendar?: CalendarProps
  slots?: SlotsProps
  errors?: FormErrorsProps['errors']
  submitButton?: ActionButtonProps
}

const RegisterTemplate: FC<RegisterTemplateProps> = (props) => {
  const { layout, registerForm, titleDescription, calendar, slots, submitButton, errors } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.Box withBottomBorder>
          <SC.TitleDescriptionStyled {...titleDescription} />
        </SC.Box>
        <SC.FormContentBox withBottomBorder>
          <RegisterForm {...registerForm} />
        </SC.FormContentBox>
        <ContentBox>
          {calendar && <SC.Calendar {...calendar} />}
          {slots && <SC.Slots {...slots} />}
          {errors && <SC.Errors errors={errors} />}
          {submitButton && (
            <SC.Centered>
              <SC.Button {...submitButton} />
            </SC.Centered>
          )}
        </ContentBox>
      </SC.Content>
    </DefaultLayout>
  )
}

export default RegisterTemplate
